import { motion } from "framer-motion";
import { CONCEPT_FRAMES } from "../lib/homevision";
import { fadeUp, viewportOnce } from "../lib/motion";

const VisionFrames = () => (
    <section
        id="frames"
        data-testid="vision-frames"
        className="relative bg-ink pb-24 lg:pb-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    CONCEPT FRAMES
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    05 VIEWS
                </p>
            </motion.div>

            <div className="mt-14 grid gap-8 lg:grid-cols-12 lg:gap-x-8 lg:gap-y-16">
                {CONCEPT_FRAMES.map((f) => (
                    <motion.figure
                        key={f.code}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={viewportOnce}
                        data-testid={`concept-frame-${f.code
                            .toLowerCase()
                            .replace(/[^a-z0-9]+/g, "-")}`}
                        className={`group relative overflow-hidden border border-white/10 bg-surface ${f.wrap}`}
                    >
                        <div className={`relative ${f.aspect}`}>
                            <img
                                src={f.image}
                                alt={f.alt}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.035]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/10 to-ink/30" />
                            <p className="absolute left-5 top-5 flex items-center gap-2.5 bg-ink/70 px-2.5 py-1.5 font-mono text-[13px] tracking-[0.22em] text-white/85 backdrop-blur-sm">
                                <span className="h-1 w-1 bg-accent" />
                                {f.code}
                            </p>
                            <figcaption className="absolute inset-x-0 bottom-0 flex items-baseline justify-between p-6 md:p-8">
                                <span className="font-display text-2xl font-semibold tracking-tight text-white md:text-3xl">
                                    {f.title}
                                </span>
                                <span className="hidden h-px flex-1 self-center bg-white/15 sm:mx-6 sm:block" />
                                <span className="hidden font-mono text-[13px] tracking-[0.2em] text-mist sm:block">
                                    HOME VISION
                                </span>
                            </figcaption>
                        </div>
                    </motion.figure>
                ))}
            </div>
        </div>
    </section>
);

export default VisionFrames;
